// components/ui/table/Table.jsx
export const Table = ({ children, className = "" }) => {
  return (
    <div className="w-full overflow-auto">
      <table className={`w-full caption-bottom text-sm ${className}`}>
        {children}
      </table>
    </div>
  );
};
